var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _g, _g2, _path12, _path13, _path14, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMyEmptyLeagues(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 245,
    height: 154,
    viewBox: "0 0 245 154",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.54026 60.8975C7.04603 60.8975 9.08051 62.9231 9.08051 65.4179C9.08051 67.9127 7.04603 69.9383 4.54026 69.9383C2.03449 69.9383 0 67.9127 0 65.4179C0 62.9231 2.03449 60.8975 4.54026 60.8975Z",
    fill: "#B3C3C6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M213.392 97.0605C215.898 97.0605 217.932 99.0861 217.932 101.581C217.932 104.076 215.898 106.101 213.392 106.101C210.886 106.101 208.852 104.076 208.852 101.581C208.852 99.0861 210.886 97.0605 213.392 97.0605Z",
    fill: "#B3C3C6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M173.665 1.00195C176.171 1.00195 178.206 3.02756 178.206 5.52238C178.206 8.0172 176.171 10.0428 173.665 10.0428C171.159 10.0428 169.125 8.0172 169.125 5.52238C169.125 3.02756 171.159 1.00195 173.665 1.00195Z",
    stroke: "#B3C1C6",
    strokeWidth: 1.79088
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M41.71 25.4122C38.1 26.4411 34.3228 24.3512 33.2806 20.7482C32.2383 17.1453 34.3231 13.3845 37.9331 12.3556C41.5431 11.3267 45.3203 13.4166 46.3625 17.0196C47.4048 20.6225 45.32 24.3833 41.71 25.4122Z",
    stroke: "#B3C1C6",
    strokeWidth: 1.79172
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M18.8604 116.019L15.4253 106.42L16.4939 106.043L19.929 115.641L18.8604 116.019ZM13.5937 113.074L13.212 112.007L21.7606 108.988L22.1422 110.054L13.5937 113.074Z",
    fill: "#CAD4D6"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M241.247 64.1259L232.925 58.2313L233.584 57.3094L241.906 63.204L241.247 64.1259ZM235.242 64.7325L234.317 64.0776L239.589 56.7028L240.514 57.3577L235.242 64.7325Z",
    fill: "#CAD4D6"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M122.347 18.4788L113.451 13.4906L114.01 12.5046L122.905 17.4929L122.347 18.4788ZM116.438 19.7127L115.45 19.1585L119.918 11.2707L120.907 11.825L116.438 19.7127Z",
    fill: "#CAD4D6"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M132.909 91.1221L152.948 111.074L141.997 121.977L121.958 102.025L132.909 91.1221Z",
    fill: "#D7D7D7"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M153.103 103.733L177.537 128.062C180.012 130.525 180.013 134.523 177.541 136.985L167.644 146.839C165.172 149.3 161.155 149.299 158.681 146.835L134.247 122.507C131.772 120.044 131.771 116.045 134.243 113.584L144.14 103.73C146.612 101.269 150.629 101.27 153.103 103.733Z",
    fill: "#969696"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M136.13 100.305C151.788 84.6124 151.754 59.1412 136.063 43.4106C120.372 27.68 94.9559 27.6545 79.304 43.3465C63.6458 59.0389 63.6736 84.5107 79.3703 100.234C95.0613 115.965 120.471 115.997 136.13 100.305Z",
    fill: "#DBDBDB"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M84.0695 49.4854C96.4312 37.1776 116.522 37.1947 128.905 49.5237C141.288 61.8526 141.305 81.8557 128.944 94.1635C116.582 106.471 96.4911 106.454 84.108 94.1252C71.725 81.7963 71.7077 61.7932 84.0695 49.4854Z",
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.92
  }, /*#__PURE__*/React.createElement("path", {
    d: "M97.278 63.2383C98.8327 63.2383 100.095 65.6335 100.095 68.5837C100.095 71.5338 98.8327 73.9291 97.278 73.9291C95.7232 73.9291 94.4609 71.5338 94.4609 68.5837C94.4609 65.6335 95.7232 63.2383 97.278 63.2383Z",
    fill: "#575757"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.92
  }, /*#__PURE__*/React.createElement("path", {
    d: "M115.048 63.2383C116.603 63.2383 117.865 65.6335 117.865 68.5837C117.865 71.5338 116.603 73.9291 115.048 73.9291C113.494 73.9291 112.231 71.5338 112.231 68.5837C112.231 65.6335 113.494 63.2383 115.048 63.2383Z",
    fill: "#575757"
  }))), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M143.2 72.0535C149.5 72.0535 154.609 68.3367 154.609 63.7491C154.609 59.1615 143.2 48.0742 143.2 48.0742C143.2 48.0742 131.792 59.1615 131.792 63.7491C131.792 68.3367 136.9 72.0535 143.2 72.0535Z",
    fill: "url(#paint0_linear_3258_15701)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M113.095 84.2177C104.427 79.903 97.4789 84.7127 98.6202 84.4662C103.611 83.3895 113.427 84.3834 113.095 84.2177Z",
    fill: "#748394"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M103.118 149.407C109.53 149.407 114.737 150.345 114.737 151.499C114.737 152.654 109.53 153.592 103.118 153.592C96.7047 153.592 91.498 152.654 91.498 151.499C91.498 150.345 96.7047 149.407 103.118 149.407Z",
    fill: "#D8DBDF"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3258_15701",
    x1: 143.212,
    y1: 54.2356,
    x2: 149.62,
    y2: 72.0714,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B0F9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#B6F3FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BCEEFD"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMyEmptyLeagues);
export default __webpack_public_path__ + "static/media/my-empty-leagues.f5aa533b233337fb9087b30dcd2408b7.svg";
export { ForwardRef as ReactComponent };